const PREFIX = 'APP'

export const APP_INIT = `${PREFIX}_INIT`
export const APP_SHOW_ALERT = `${PREFIX}_SHOW_ALERT`
export const APP_HIDE_ALERT = `${PREFIX}_HIDE_ALERT`
export const APP_SET_SESSION_ID = `${PREFIX}_SET_SESSION_ID`
export const SET_SEARCHING=`${PREFIX}_SET_SEARCHING`
export const SET_SEARCH_TEXT_CLEAR=`${PREFIX}_TEXT_SET_CLEAR`